/* eslint-disable quote-props */

const en = {
  translations: {
    // nhc menu
    'คลังข้อมูลน้ำแห่งชาติ': 'National Hydroinformatics Data Center',

    // top menu
    'ภาพรวมประเทศไทย': 'Thailand Overview',
    'แนะนำการใช้งาน': 'User Guide',
    'เกี่ยวกับเรา': 'About Us',
    'ติดต่อเรา': 'Contact Us',

    // main menu
    'ฝน 24 ชม.': '24hr Rainfall',
    'ระดับน้ำ': 'Water Level',
    'แหล่งน้ำ': 'Reservoir',
    'คุณภาพน้ำ': 'Water Quality',
    'พื้นที่ประกาศภัย': 'Declared Disaster Area',
    'พายุ': 'Storm',
    'เรดาร์': 'Weather Radar',
    'คาดการณ์ฝน': 'Rainfall Forecast',
    'คาดการณ์คลื่น': 'Wave Forecast',
    'คาดการณ์น้ำท่วมฉับพลัน': 'Flash Flood Forecast',
    'คาดการณ์ความเค็ม': 'Salinity Forecast',
    'ติดตามภัยแล้ง': 'Drought Monitor',
    'รายละเอียด': 'Descritption',
    'เตือนภัยน้ำหลากดินถล่ม': 'Early Warning System',
    'เตือนภัยน้ำหลากดินถล่ม (EWS)': 'Early Warning System',

    // sidebar menu
    'ดูข้อมูล': 'Filter',
    'สำหรับเจ้าหน้าที่': 'For ONWR',
    'เปลี่ยนรหัสผ่าน': 'Change Password',
    'เข้าระบบหลังบ้าน': 'Backoffice Login',
    'ชื่อผู้ใช้งาน': 'Username',
    'รหัสผ่าน': 'Password',
    'ลืมรหัสผ่าน': 'Forgot Password',
    'รหัสผ่านเดิม': 'Old Password',
    'รหัสผ่านใหม่': 'New Password',
    'ยืนยันรหัสผ่านใหม่': 'Confirm Password',
    'ตกลง': 'OK',
    'เข้าสู่ระบบ': 'Log In',
    'ออกจากระบบ': 'Log out',
    'ระบบได้ส่งลิงค์ยืนยันตั้งรหัสผ่านใหม่ของคุณ ทางอีเมล์เรียบร้อยแล้ว': 'A password reset link has been sent to your email address.',
    'กรุณายืนยัน': 'Please confirm',
    'ป้อนอีเมล์ของคุณ': 'Enter your email address',

    // model menu
    'ข้อมูลคาดการณ์จากแบบจำลอง': 'Rainfall Forecasting System',
    'ระบบเตือนภัยน้ำท่วมฉับพลันด้วยค่าดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน': 'Flash Flood Warning System using Flash Flood Potential Index (FFPI)',
    'ระบบวิเคราะห์ปริมาณฝนสูงสุดรายอำเภอ': 'Analysis System of Highest Rainfall by District',
    'ระบบประเมินปริมาณน้ำฝนและพยากรณ์ฝนล่วงหน้า': 'Rainfall Forecasting System',
    'ระบบแสดงแผนที่ฝนคาดการณ์รายเดือน': 'Monthly Rainfall Prediction System',
    'ระบบติดตามภัยแล้ง': 'Drought Monitoring System',
    'ระบบคาดการณ์ความเค็มรุกตัวในแม่น้ำเจ้าพระยาตอนล่าง': 'Salinity Intrusion Forecasting system in Lower Chao Phraya River',
    'ระบบคาดการณ์น้ำท่า': 'Water Level Forcasting System',

    // rain page
    'ฝน': 'Rainfall',
    'ฝน 24 ชั่วโมง': '24hr Rainfall',
    'ฝนวันนี้': "Today's Rainfall",
    'ฝนวานนี้': "Yesterday's Rainfall",
    'ฝน 3 วัน': '3-day Rainfall',
    'ฝน 7 วัน': '7-day Rainfall',
    'ฝนรายเดือน': 'Monthly Rainfall',
    'ฝนรายปี': 'Annual Rainfall',
    'ฝนสะสม': 'Accumulated Rainfall',
    'ฝนสถิติ': 'Rainfall Statistics',
    'เกณฑ์ฝนสะสมรายปี': 'Annual Rainfall Color Scale',
    'แสดงเกณฑ์ฝนสะสมรายปี': 'Show Annual Rainfall Color Scale',
    'ฝนล่าสุด': 'Latest Rainfall',
    '(มม.)': '(mm)',
    'เดือน-ปี': 'month-year',
    'เดือน': 'Month',
    'ฝนสะสม 24 ชม. ย้อนหลัง': 'Past 24-hour Accumulated Rainfall',
    'ปริมาณฝนสะสมตั้งแต่เวลาปัจจุบันย้อนหลังไป 24 ชั่วโมง': 'Past 24-hour Accumulated Rainfall from present time',
    'ปริมาณฝนสะสมตั้งแต่เวลา 7.00 น. ของวันนี้ จนถึงเวลาปัจจุบันของวันนี้': 'Accumulated Rainfall from 7.00 am today to present time',
    'ปริมาณฝนสะสมที่เกิดขึ้นตั้งแต่ 7.00 น. ของวันก่อนหน้าถึง 7.00 น. ของวันปัจจุบัน': 'Accumulated Rainfall from 7.00 am the day before to 7.00 am this day',
    'ผลรวมของฝนรายวันจำนวน 3 วัน': 'Total 3-day rainfall',
    'ผลรวมของฝนรายวันจำนวน 7 วัน': 'Total 7-day rainfall',
    'เกณฑ์ฝน': 'Rainfall Criteria/Rainfall Color Scale',
    'ฝนสะสม 24 ชม (มม.)': '24-hour Accumulated Rainfall (mm)',
    'ฝนสะสม (มม.)': 'Accumulated Rainfall (mm)',
    'ฝนสะสม 1 ชม (มม.)': '1-hour Accumulated Rainfall (mm)',
    'นับเฉพาะขั้นวิกฤติ': 'Count only Critical Level',
    'ดาวน์โหลดไฟล์ ฝน': 'Download Rainfall Data',
    'ปริมาณฝน (มม.)': 'Rainfall (mm)',
    'ฝนมาก': 'Heavy Rain',
    'ฝนน้อย': 'Light Rain',
    'เกณฑ์': 'Criteria/Color Scale',
    'เกณฑ์ฝนสะสม 3 วัน': '3-day Rainfall Color Scale',
    'แสดงเกณฑ์ฝน 3 วัน': 'Show 3-day Rainfall Color Scale',
    'แสดงเกณฑ์': 'Show Color Scale',
    'กราฟฝนสะสม 3 วัน': '3-day Accumulated Rainfall Graph',
    'ดาวน์โหลดข้อมูล ฝน 3 วัน': 'Download 3-day Rainfall Data',
    'กราฟฝนสะสม 7 วัน': '7-day Accumulated Rainfall Graph',
    'ดาวน์โหลดข้อมูล ฝน 7 วัน': 'Download 7-day Rainfall Data',
    'ไม่มีข้อมูลฝน': 'No data',
    'ดาวน์โหลดข้อมูล ฝน 24 ชั่วโมง': 'Download 24-hour Rainfall Data',
    'ดาวน์โหลดข้อมูล ฝนรายเดือน': 'Download Monthly Rainfall Data',
    'กราฟฝน': 'Rainfall Graph',
    'ดาวน์โหลดข้อมูล ฝนรายปี': 'Download Annual Rainfall Data',
    'ดาวน์โหลดข้อมูล ฝนวันนี้': "Download Today's Rainfall Data",
    'ดาวน์โหลดข้อมูล ฝนวานนี้': "Download Yesterday's Rainfall Data",
    'ปริมาณฝน': 'Rainfall',
    'ปริมาณฝนสะสม 7 วัน': '7-day Accumulated Rainfall',
    'ปริมาณฝนสะสม 3 วัน': '3-day Accumulated Rainfall',
    'ปริมาณฝนสะสมรายวัน': 'Daily Accumulated Rainfall',
    'ปริมาณฝนรายวัน': 'Daily Rainfall',
    'ปริมาณฝนวันนี้': "Today's Rainfall",
    'ปริมาณฝนรายชั่วโมง': 'Hourly Rainfall',
    'ปริมาณฝนสะสม': 'Accumulated Rainfall',
    'ภาพ isohyet': 'Isohyet',
    'ไม่มีข้อมูลฝนรายชั่วโมง': 'No Rainfall Hourly data',

    // dam page
    'แหล่งน้ำขนาดใหญ่': 'Large Reservoirs',
    'แหล่งน้ำขนาดใหญ่ กรมชลฯ': 'Large Reservoirs RID',
    'แหล่งน้ำขนาดใหญ่ การไฟฟ้า': 'Large Reservoirs EGAT',
    'แหล่งน้ำขนาดกลาง': 'Medium Reservoirs',
    'ภาพรวมสถานการณ์ล่าสุด': 'Latest Overview',
    'สถิติแหล่งน้ำขนาดใหญ่': 'Large Reservoirs Statistics',
    'สถิติแหล่งน้ำขนาดกลาง': 'Medium Reservoirs Statistics',
    'แสดงทุกปริมาณน้ำ': 'Show all',
    'อ่างขนาดใหญ่': 'Large Reservoirs',
    'อ่างขนาดกลาง': 'Medium Reservoirs',
    'อ่างเก็บน้ำ': 'Reservoirs',
    'ความจุ': 'Capacity',
    'ความจุที่ รนก.': 'Capacity at NPL',
    'ความจุน้ำใช้การ': 'Capacity Usable Water',
    'ปริมาณน้ำ': 'Storage',
    'ปริมาตรใช้การ': 'Usable Volume',
    'ปริมาตรน้ำใช้การ': 'Usable Water Volume',
    'น้ำไหลลง': 'Inflow',
    'น้ำระบาย': 'Release',
    'ปริมาณน้ำกักเก็บ': 'Storage',
    'น้ำไหลลง / ระบาย': 'Inflow/Release',
    'ล้าน ลบ.ม': 'MCM',
    ' ล้าน ลบ.ม.': ' MCM',
    'ล้าน ลบ.ม (% ความจุ)': 'MCM (%Capacity)',
    'ล้าน ลบ.ม. (% ความจุ)': 'MCM (%Capacity)',
    'ล้าน ลบ.ม (% น้ำใช้การได้)': 'MCM (%Usable Volume)',
    'ล้าน ลบ.ม. (%น้ำใช้การ)': 'MCM (%Usable Volume)',
    '(% ความจุที่ รนก.)': '(% Capacity At NPL)',
    '(% ความจุน้ำใช้การ)': '(% Capacity Usable Water)',
    'ประเภทข้อมูล': 'Data Type',
    'ปี (สูงสุด 8 ปี)': 'Year (Up to 8 years)',
    'ไม่มีข้อมูลแหล่งน้ำขนาดใหญ่ ตามเงื่อนไข': 'Large Reservoirs Data Not Found under Selected Condition',
    'ที่ รนส.': 'At MPL (Maximum Pool Level)',
    'ที่ รนก.': 'At NPL (Normal Pool Lel)',
    'ที่ น้ำใช้การ': 'At Usable Water',
    'พิ้นที่': 'Area',
    'น้ำในอ่าง': 'Storage',
    'ปริมาณน้ำไหลลงอ่าง': 'Inflow',
    'ปริมาณน้ำระบาย': 'Release',
    'ค่าเฉลี่ยรวมทั้งปี': 'Annual Average',
    'ปริมาตรน้ำ': 'Water Volume',
    'สะสมตั้งแต่ 1 ม.ค.': 'Accumulated Since 1 January',
    'ภาคเหนือ': 'North',
    'รวมภาคเหนือ': 'Total in North',
    'ภาคตะวันออกเฉียงเหนือ': 'Northeast',
    'รวมภาคตะวันออกเฉียงเหนือ': 'Total in Northeast',
    'ภาคกลาง': 'Central',
    'รวมภาคกลาง': 'Total in Central',
    'ภาคตะวันตก': 'West',
    'รวมภาคตะวันตก': 'Total in West',
    'ภาคตะวันออก': 'East',
    'รวมภาคตะวันออก': 'Total in East',
    'ภาคใต้': 'South',
    'รวมภาคใต้': 'Total in South',
    'รวมทั้งประเทศ': 'Total',
    'คำย่อ': 'Abbreviations',
    'รนส. หมายถึง ระดับน้ำสูงสุด': 'MPL is an abbreviation of Maximum Pool Level',
    'รนก. หมายถึง ระดับน้ำกับเก็บ': 'NPL is an abbreviation of Normal Pool Level',
    'กักเก็บต่ำสุด': 'Dead Storage',
    'น้ำน้อยวิกฤต (%น้ำใช้การฯ)': 'Critically Low Level (%Usable Water)',
    'น้ำมากวิกฤต (%ความจุ)': 'Critically High Level (%Capacity)',
    'ม.รทก.': 'm MSL',
    'เกณฑ์แหล่งน้ำ': 'Reservoir Criteria',
    'ปริมาณน้ำกักเก็บปัจจุบัน (% รนก.)': 'Storage (%NPL)',
    'กราฟอ่างเก็บน้ำรายวัน กรมชลประทาน': 'Daily Reservoir Graph, RID',
    'กราฟอ่างเก็บน้ำรายวัน การไฟฟ้า': 'Daily Reservoir Graph, EGAT',
    'กราฟอ่างเก็บน้ำขนาดกลางรายวัน กรมชลประทาน': 'Daily Medium Reservoir Graph, RID',
    'ไม่มีข้อมูลแหล่งน้ำขนาดกลาง ตามเงื่อนไข': 'Medium Reservoirs Data Not Found under Selected Condition',
    'กราฟรายปี': 'Yearly Graph',
    'รวม': 'Total',
    'กักเก็บปกติ (ล้าน ลบ.ม.)': 'Normal Storage (MCM)',
    'กักเก็บต่ำสุด (ล้าน ลบ.ม.)': 'Dead Storage (MCM)',
    'กักเก็บ (ล้าน ลบ.ม.)': 'Storage (MCM)',
    'กักเก็บ (% ความจุ)': 'Storage (%Capacity)',
    'ปริมาตรใช้การ (ล้าน ลบ.ม.)': 'Usable Water (MCM)',
    'น้ำไหลลง (ล้าน ลบ.ม.)': 'Inflow (MCM)',
    'น้ำระบาย (ล้าน ลบ.ม.)': 'Release (MCM)',
    'ดาวน์โหลดไฟล์ อ่างเก็บน้ำ': 'Download Reservoir File',
    'แหล่งน้ำอื่นๆ ที่เกี่ยวข้อง': 'Other Water Resources',
    'รวมแหล่งน้ำอื่นๆ ที่เกี่ยวข้อง': 'Total in Other Water Resources',
    'รวมแหล่งน้ำขนาดใหญ่': 'Total in Large Reservoirs',
    'รวมแหล่งน้ำขนาดกลาง': 'Total in Medium Reservoirs',
    'ดาวน์โหลดข้อมูล แหล่งน้ำขนาดกลาง': 'Download Large Reservoir Data',
    'ดาวน์โหลดข้อมูล แหล่งน้ำขนาดใหญ่': 'Download Medium Reservoir Data',
    'ความจุ (ล้าน ลบ.ม.)': 'Storage (MCM)',
    'ความจุอ่างที่ รนส. (ล้าน ลบ.ม.)': 'Storage at MPL (MCM)',
    'ความจุอ่างที่ รนก. (ล้าน ลบ.ม.)': 'Storage at NPL (MCM)',
    'ความจุอ่างที่ น้ำใช้การ (ล้าน ลบ.ม.)': 'Storage at Usable Water (MCM)',
    'คิดเป็น % ของน้ำเต็มอ่าง': '% Capacity',
    'น้ำในอ่าง กักเก็บ (ล้าน ลบ.ม.)': 'Storage (MCM)',
    'น้ำในอ่าง กักเก็บ (% ความจุ)': 'Storage (%Capacity)',
    'น้ำในอ่าง ปริมาตรใช้การ (ล้าน ลบ.ม.)': 'Usable Water (MCM)',
    'น้ำในอ่าง ปริมาตรใช้การ (% ความจุ)': 'Usable Water (%Capacity)',
    'ปริมาณน้ำไหลลงอ่าง ค่าเฉลี่ยรวมทั้งปี (ล้าน ลบ.ม.)': 'Average Annual Inflow (MCM)',
    'ปริมาณน้ำไหลลงอ่าง ปริมาตรน้ำ (ล้าน ลบ.ม.)': 'Inflow (MCM)',
    'ปริมาณน้ำไหลลงอ่าง สะสมตั้งแต่ 1 ม.ค. (ล้าน ลบ.ม.)': 'Inflow Accumulated since 1 January (MCM)',
    'ปริมาณน้ำไหลลงอ่าง สะสมตั้งแต่ 1 ม.ค. (% ความจุ)': 'Inflow Accumulated since 1 January (%Capacity)',
    'ปริมาณน้ำระบาย ปริมาตรน้ำ (ล้าน ลบ.ม.)': 'Release (MCM)',
    'ปริมาณน้ำระบาย สะสมตั้งแต่ 1 ม.ค. (ล้าน ลบ.ม.)': 'Release Accumulated since 1 January (MCM)',
    'กราฟอ่างเก็บน้ำรายวัน รายภาค กรมชลประทาน': 'Regional Daily Reservoir Graph, RID',
    'กราฟอ่างเก็บน้ำรายวัน รายภาค การไฟฟ้า': 'Regional Daily Reservoir Graph, EGAT',
    'ปริมาณน้ำเก็บกัก': 'Storage',
    'ปริมาณน้ำใช้การ': 'Usable Water',
    'ปริมาณน้ำไหลลง': 'Inflow',
    'ปริมาณน้ำไหลลงสะสม': 'Accumulated Inflow',
    'ปริมาณน้ำระบายสะสม': 'Accumulated Release',
    'เปรียบเทียบวันที่': 'The date compared',
    'น้ำใช้การได้': 'Usable Volume',
    'กักเก็บสูงสุด': 'Maximum Volume',
    'กักเก็บปกติ': 'Normal Storage',
    'ปริมาณน้ำไหลเข้าสะสม': 'Accumulated Inflow',

    // wl page
    '(ม.รทก)': '(m MSL)',
    'ระดับน้ำในแม่น้ำ': 'River Water Level',
    'ระดับน้ำ ปตร./ฝาย': 'Floodgate Water Level',
    'ระดับน้ำเหนือ': 'Upstream Level',
    'ระดับน้ำท้าย': 'Downstream Level',
    'น้ำระบายสูงสุดปัจจุบัน': 'Present Maximum Discharge',
    'กล้อง CCTV': 'CCTV Camera',
    'หน่วยงาน': 'Agency',
    'ทุกหน่วยงาน': 'All Agencies',
    'สถานการณ์': 'Situation',
    'ทุกสถานการณ์': 'All Situations',
    'สถานีหลัก': 'Main Station',
    'ระดับตลิ่ง': 'Bank Level',
    'ค่าศูนย์เสาระดับ': 'Zero Gauge',
    '% ความจุลำน้ำ': '%Qmax',
    'ความจุลำน้ำ': 'Qmax',
    'ล้นตลิ่ง': 'Overflow',
    'สูงกว่าตลิ่ง': 'Above bank',
    'ต่ำกว่าตลิ่ง': 'Below bank',
    'ระดับน้ำปตร': 'Floodgate Water Level',
    'ภาพ': 'Picture',
    'ระดับท้องน้ำ': 'River Bed',
    'ปริมาณความจุลำน้ำ': 'Qmax',
    'เกณฑ์ระดับน้ำ': 'Water Level Criteria',
    'กราฟระดับน้ำ': 'Water Level Graph',
    'กราฟระดับน้ำปตร./ฝาย': 'Floodgate Water Level Graph',
    'ปตร./ฝาย': 'Floodgate/Weir',
    'ดาวน์โหลดข้อมูล CCTV': 'Download CCTV Data',
    'แสดงข้อมูล CCTV': 'Show CCTV Data',
    'ดาวน์โหลดข้อมูล ระดับน้ำปตร.': 'Download Floodgate Water Level Data',
    'คลิ๊กเพื่อแสดงกราฟ': 'Click to Show Graph',
    'ดาวน์โหลดข้อมูล ระดับน้ำ': 'Download Water Level Data',
    'ดูภาพ / วีดีโอ': 'View Picture/Video',
    'จุดที่มีระดับน้ำสูงสุด': 'Highest water level point',
    'ต่ำสุด': 'Lowest',
    'โทรมาตร': 'Telemetry',
    'คลอง': 'Canal',

    // waterquality page
    'กรด-ด่าง': 'pH',
    'กรดด่าง': 'pH',
    'ความเค็ม': 'Salinity',
    'ความขุ่น': 'Turbidity',
    'สารละลาย': 'Total Dissolved Solids (TDS)',
    'ออกซิเจน': 'Dissolved Oxygen (DO)',
    'พารามิเตอร์': 'Parameter',
    'สถานีคุณภาพน้ำ': 'Water Quality Station',
    'เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'Exceed the Water Quality Criteria for Tap Water Production',
    'เกณฑ์ปกติ': 'Normal Criteria',
    'เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร': 'Exceed the Water Standard Criteria for Agriculture',
    'เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา': 'Water Quality Monitoring Criteria for Tap Water Production',
    'เกณฑ์คุณภาพน้ำ': 'Water Quality Criteria',
    'เปรียบเทียบสถานีคุณภาพน้ำ': 'Compare Water Quality Stations',
    'แสดงตำแหน่งบนแผนที่': 'Show the location on the map',
    'คลิ๊กเพื่อแสดงกราฟคุณภาพน้ำ': 'Click to Show Water Quality Graph',
    'ดาวน์โหลดข้อมูลคุณภาพน้ำ': 'Download Water Quality Data',
    'มากกว่า 2 เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร': 'Greater than 2: Exceed the Water Standard Criteria for Agriculture',
    'มากกว่า 0.5 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'Greater than 0.5: Exceed the Water Quality Criteria for Tap Water Production',
    'มากกว่า 0.25 เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา': 'Greater than 0.25: Exceed the Water Quality Monitoring Criteria for Tap Water Production',
    'น้อยกว่า 5 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'Lower than 5: Exceed the Water Quality Criteria for Tap Water Production',
    'มากกว่า 9 เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา': 'Greater than 9: Exceed the Water Quality Criteria for Tap Water Production',
    'ความเค็ม(g/L)': 'Salinity (g/L)',
    'ออกซิเจนในน้ำ(mg/L)': 'Oxygen in water(mg/L)',
    'กรด-ด่าง(pH)': 'pH',
    'ความขุ่น(ntu)': 'Turbidity (ntu)',
    'สารละลาย(mg/L)': 'Total Dissolved Solids (mg/L)',
    'คำอธิบาย': 'Description',

    // risk page
    'ขอบเขตพื้นที่ประกาศภัย': 'Declared Disaster Area',
    'รายงานการให้ความช่วยเหลือ': 'Report of Assisting Affected People',
    'ภาพรวมทั้งประเทศ': 'Thailand Overview',
    'ฝนสะสม 1 วัน': 'Rainfall Accumulation 1 Day',
    'ฝนสะสม 2 วัน': '2-day Rainfall',
    'ฝนสะสม 3 วัน': 'Rainfall Accumulation 3 Days',
    'ฝนสะสม 7 วัน': 'Rainfall Accumulation 7 Days',
    'ฝนสะสม 15 วัน': 'Rainfall Accumulation 15 Days',
    'ฝนสะสม 30 วัน': 'Rainfall Accumulation 30 Days',
    'อุณหภูมิในรอบสัปดาห์': 'Weekly Temperature',
    'สูงสุด': 'Maximum',
    'ปริมาณน้ำใช้การรวม เขื่อนหลัก วันนี้ปีที่ผ่านมา': 'Total Usable Water Volume of the Main Reservoirs a Year Ago Today',
    'ฝนสูงสุดวานนี้': "Yesterday's Highest Rainfall",
    'อุณหภูมิในรอบสัปดาห์  สูงสูด': 'Weekly Highest Temperature',
    'ปริมาตรน้ำใช้การของแหล่งน้ำในจังหวัด': 'Usable Water Volume of Reservoirs in the Province',
    'วันนี้ปีที่ผ่านมา (ล้าน ลบ.ม/% น้ำใช้การ)': 'A Year Ago Today (MCM/%Usable Volume)',
    'เครื่องมือและอุปกรณ์': 'Tools and Equipments',
    'ยังไม่มีการเชื่อมโยงข้อมูล': 'There is no data link.',
    'รวมแหล่งน้ำขนาดใหญ่และขนาดกลาง': 'Sum of Large and Medium Reservoirs',
    'ล้านลูกบาศก์เมตร': 'Million Cubic Meters',
    'น้ำใช้การ': 'Usable Volume',
    'สถานีวัดระดับน้ำ': 'Water Level Station',
    'วันนี้': 'Today',
    'พรุ่งนี้': 'Tomorrow',
    'มะรืนนี้': 'Day After Tomorrow',
    'ไม่มีฝน': 'No Rrain',
    'ปริมาณน้ำฝน': 'Rainfall',

    // storm page
    'แผนที่วิเคราะห์เส้นทาง และความแรงของพายุ': 'Analysis Map of Strom Track and Strength',
    'แผนที่เส้นทางพายุที่อาจส่งผลกระทบต่อประเทศไทย': 'Map of Storm Track that may affect Thailand',
    'ภาพเมฆที่ปกคลุมบริเวณประเทศไทย': 'Picture of Cloud Covering Thailand',
    'มหาสมุทรแปซิฟิก': 'Pacific Ocean',
    'มหาสมุทรอินเดีย': 'Indian Ocean',
    'เกณฑ์พายุ': 'Storm Criteria',
    'ข้อมูลเกณฑ์พายุ': 'Storm Criteria Data',
    'ไม่มีพายุ': 'No Storm',
    'ความเร็ว': 'Wind Speed',
    'แผนที่พายุและความแรงพายุขณะนี้': 'Map of Current Storm Track and Strength',
    'ภาพพายุหมุนในอดีต': 'Map of Historical Storm Tracks',
    'ความหมายและที่มาของชื่อพายุ': 'Meaning and Origin of Storm Names',
    'ไม่พบข้อมูลพายุ ตามเงื่อนไข': 'No Data',
    'ค้นหาพายุ': 'Search',
    'เดือน (แสดงทุกเดือน)': 'Month (All)',
    'ปี (สูงสุด 5 ปี)': 'Year (Max 5 year)',
    'รายชื่อพายุบริเวณมหาสมุทรอินเดียเหนือ': 'List of Storms in the North Indian Ocean',
    'รายชื่อพายุบริเวณมหาสมุทรแปซิฟิกด้านตะวันตกตอนบนและทะเลจีนใต้': 'List of Storms in the Upper Western Pacific Ocean and the South China Sea',
    'ลำดับที่': 'No.',
    'หมายเหตุ': 'Note',
    'ชุดที่': 'List',
    'ชื่อภาษาอังกฤษ': 'English Name',
    'ชื่อพายุ': 'Storm Name',
    'ประเทศที่มาของชื่อ': 'Country of Origin',
    'การตั้งชื่อพายุหมุนเขตร้อนจะหมุนเวียนกันไปตามลำดับ และอ่านออกเสียงชื่อพายุตามราชบัณฑิตยสภา': 'The naming of tropical storms will rotate in sequence and pronunication of storm names is based on the Royal Society.',
    'รายชื่อพายุนี้แก้ไขปรับปรุงในการประชุมทางไกลผ่านจอภาพของคณะกรรมการไต้ฝุ่นครั้งที่ 53 ระหว่างวันที่ 23-25 กุมภาพันธ์ 2564': "The list of storms was revised at the 53rd Typhoon Committee's video conference during 23-25 February, 2021.",
    'ส่วนวิจัยและความร่วมมือทางวิชาการ กองพัฒนาอุตุนิยมวิทยา/มีนาคม 2564': 'Research and Academic Cooperation Section, Meteorological Department Devision/March 2021',
    'เสนอชื่อโดยประเทศริมมหาสมุทรอินเดีย 13 ประเทศ ข้อมูลปี พ.ศ.2563': 'Assigned names by 13 Indian Ocean Rim Countries, 2020 data',

    // radar page
    'รัศมี 240 กม.': '240 km radius',
    'รัศมี 160 กม.': '160 km radius',
    'รัศมี 120 กม.': '120 km radius',
    'ข้อมูลจากกรมอุตุนิยมวิทยา, กรมฝนหลวงการบินและการเกษตร, สำนักระบายน้ำ กรุงเทพมหานคร': 'ข้อมูลจากกรมอุตุนิยมวิทยา, กรมฝนหลวงการบินและการเกษตร, สำนักระบายน้ำ กรุงเทพมหานคร',

    // wave page
    'แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองคลื่นทะเล (SWAN Model)': '7-day High Resolution Wave Height and Wave Direction from SWAN model',
    'แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน': '7-day in advance',
    'เกณฑ์ข้อมูลคลื่น': 'Wave Criteria',
    'คลื่นสูงมากกว่า 2 เมตร': 'Wave Height Over 2.0 m',

    // forecast rainfall
    'แผนภาพคาดการณ์ฝนล่วงหน้า 7 วัน ความละเอียดสูงจากแบบจำลองสภาพอากาศ WRF-ROMS Model โดย สสน.': '7-day High Resolution Rainfall Forecast Map from WRF-ROMS by HII',
    'แผนภาพคาดการณ์ฝนเชิงพื้นที่ จากแบบจำลองอากาศเชิงตัวเลขด้วยคอมพิวเตอร์สมรรถนะสูง (TMD-WRF) โดย กรมอุตุนิยมวิทยา': 'Spatial Rainfall Forecast Map from Numerical Model using High Performance Computing by TMD',
    'โดยทั่วไปความแม่นยำของการคาดการณ์สภาวะฝนจะลดลงเมื่อระยะเวลาคาดการณ์ยาวขึ้น โดยจะมีความแม่นยำสูงสุดที่ 3 วันข้างหน้า โปรดใช้วิจารณญาณในการนำข้อมูลไปใช้': 'In general, the accuracy of rainfall forecasts decreases as the forecast period increases. The forecasts will be most accurate for the next 3 days. Please use discretion when using this information.',
    'เปรียบเทียบ แผนภาพคาดการณ์ฝน': 'Compare Rainfall Forecast Map',
    'เปรียบเทียบ แผนภาพคาดการณ์ฝน WRF-ROMS Model กับ TMD-WRF Model': 'Compare Rainfall Forecast Map of WRF-ROMS model with Rainfall Forecast Map of TMD-WRF Model',
    'เกณฑ์คาดการณ์ฝน': 'Rainfall Forecast Criteria',
    'กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา': 'Weather Forecast Division, Thai Meteorological Department',
    'MSLP และ precipitation 24 ชม. จัดทำโดย กองพยากรณ์อากาศ กรมอุตุนิยมวิทยา': 'MSLP and 24-hr Precipitation by Weather Forecast Division, Thai Meteorological Department',
    'แผนภาพคาดการณ์ฝน ล่วงหน้า 7 วัน': '7-day Rainfall Forecast',
    'ล่วงหน้า 7 วัน': '7-day Forecast',
    'เปรียบเทียบ': 'Compare',

    // table
    'ค้นหา': 'Search',
    'ชื่อสถานี': 'Station Name',
    'สถานี': 'Station',
    'ที่ตั้ง': 'Location',
    'เวลา': 'Time',
    'แถว': 'Row',
    'หน้าแรก': 'First Page',
    'หน้าสุดท้าย': 'Last Page',
    'ก่อนหน้า': 'Previous',
    'ถัดไป': 'Next',
    'ไม่มีข้อมูลตามเงื่อนไข': 'No data',
    'กำลังโหลดข้อมูล...': 'Loading data...',

    // map
    'เส้นแม่น้ำ': 'River Line',
    'ขอบเขตการปกครอง': 'Administrative Boundary',
    'ขอบเขตลุ่มน้ำ': 'Basin Boundary',
    'แสดงเต็มหน้าจอ': 'Show Full Screen',
    'แม่น้ำ': 'River',
    'แผนที่': 'Map',

    // common
    'ล่าสุด': 'Latest',
    'ข้อมูลจาก': 'Data obtained From',
    'ข้อมูล': 'Data',
    'ที่มา': 'Source :',
    'ภาพเคลื่อนไหว': 'Animation',
    'กราฟ': 'Graph',
    'ไม่มีข้อมูล': 'No Data',
    'ไม่มีข้อมูลในช่วงเวลาที่เลือก': 'No Data under the selected time',
    'วันที่เริ่มต้น': 'Start Date',
    'วันที่สิ้นสุด': 'End Date',
    'หน่วย': 'Unit',
    'ข้อมูลวันที่': 'Data Date',
    'ความหมาย': 'Meaning',
    'วันที่': 'Date',
    'สี': 'Color',
    'ตำบล': 'Sub-dirtrict',
    'อำเภอ': 'District',
    'จังหวัด': 'Province',
    'ต.': 'ต.',
    'อ.': 'อ.',
    'จ.': 'จ.',
    'น.': 'น.',
    'ลุ่มน้ำ': 'Basin',
    'ทั่วประเทศ': 'Thailand',
    'ทุกลุ่มน้ำ': 'All Basins',
    'ค่า': 'Value',
    'เมตร': 'เมตร',
    'ดาวน์โหลด': 'Download',
    'แสดง': 'View',
    'เปลี่ยนภาษา': 'Change Language',
    'ปี': 'ํYear',
    'เลือก': 'Select',
    'ดูภาพล่าสุด': 'Latest',
    'ดูภาพย้อนหลัง': 'History',

    // rule
    'น้อยวิกฤต': 'Critically Low',
    'น้อย': 'Low',
    'ปกติ': 'Normal',
    'มาก': 'High',
    'เกินความจุ': 'Exceed Capacity',
    'ฝนเล็กน้อย': 'Light Rain',
    'ฝนปานกลาง': 'Moderate Rain',
    'ฝนหนัก': 'Heavy Rain',
    'ฝนหนักมาก': 'Very Heavy Rain',
    'เฝ้าระวังพิเศษ': 'Special Surveillance',
    'วิกฤต': 'Critical',
    'นับเฉพาะขั้น': 'Count only Critical Level',
    'น้ำน้อยวิกฤติ': 'Critically Low Water',
    'น้ำล้นตลิ่ง': 'Overflow Water',
    'เขื่อนน้ำน้อยวิกฤต (%ใช้การฯ)': 'Critically low Water Reservoir (%Usable Water)',
    'เขื่อนน้ำมากวิกฤต (% รนก.)': 'Criticallly High Water Reservoir (%NPL)',
    'มากกว่า 2 กรัม ต่อลิตร': 'Greater than 2 g/L',
    'มากกว่า 0.50 กรัม ต่อลิตร': 'Greater than 0.50 g/L',
    'มากกว่า 0.25 กรัม ต่อลิตร': 'Greater than 0.25 g/L',
    'เกินมาตรฐานคุณภาพเพื่อการผลิตน้ำประปา': 'Exceed the Quality Standard for Tap Water Production',
    'เกินมาตรฐานคุณภาพเพื่อการเกษตร': 'Exceed the Quality Standard for Agriculture',
    'เฝ้าระวังคุณภาพน้ำดินเพื่อผลิตน้ำประปา': 'Surveil the Raw Water Quality for Tap Water Production',
    'น้ำน้อย': 'Low Water',
    'น้ำปานกลาง': 'Medium water',
    'น้ำมาก': 'High water',

    // full map
    'แจ้งเตือนสถานการณ์"คาดการณ์ความเค็ม"ล่าสุด': 'Alert on the Latest "Salinity Forecasting" Situation',
    'แจ้งเตือนสถานการณ์"ติดตามภัยแล้ง"ล่าสุด': 'Alert on the Latest "Drought Monitoring" Situation',
    'ปริมาณฝนสะสม 15 วันย้อนหลัง (มม.)': 'Past 15-day Accumulated Rainfall (mm)',
    'ปริมาณฝนสะสมคาดการณ์ล่วงหน้า 7 วัน (มม.)': '7-day Accumulated Forecast Rainfall (mm)',
    'ค่าความเค็มสูงสุด': 'Highest Salinity',
    'สถานการณ์น้ำประเทศไทย': 'Water Situation in Thailand',
    'แจ้งเตือนสถานการณ์"คุณภาพน้ำ"ล่าสุด': 'Alert on the Lastest "Water Quality" Situation',
    'แจ้งเตือนสถานการณ์"แหล่งน้ำขนาดใหญ่"ล่าสุด': 'Alert on the Lastest "Large Reservoirs" Situation',
    'ฝนสะสม 1 วันล่วงหน้า': '1-day Forecast Rainfall',
    'สถานีโทรมาตรเพื่อติดตามสถานการณ์': 'Telemetering Station for Monitoring the Situation',
    'ความสูงของคลื่น': 'Wave Height',

    // month
    'มกราคม': 'January',
    'กุมภาพันธ์': 'February',
    'มีนาคม': 'March',
    'เมษายน': 'April',
    'พฤษภาคม': 'May',
    'มิถุนายน': 'June',
    'กรกฏาคม': 'July',
    'สิงหาคม': 'August',
    'กันยายน': 'September',
    'ตุลาคม': 'October',
    'พฤศจิกายน': 'November',
    'ธันวาคม': 'December',

    // credit
    'ข้อมูลจากกรมชลประทาน': 'Data from RID',

    // province
    'กรุงเทพมหานคร': 'Bangkok',
    'อำนาจเจริญ': 'Amnat Charoen',
    'อ่างทอง': 'Ang Thong',
    'บึงกาฬ': 'Bueng Kan',
    'บุรีรัมย์': 'Buri Ram',
    'ฉะเชิงเทรา': 'Chachoengsao',
    'ชัยนาท': 'Chai Nat',
    'ชัยภูมิ': 'Chaiyaphum',
    'จันทบุรี': 'Chanthaburi',
    'เชียงใหม่': 'Chiang Mai',
    'เชียงราย': 'Chiang Rai',
    'ชลบุรี': 'Chon Buri',
    'ชุมพร': 'Chumphon',
    'กาฬสินธุ์': 'Kalasin',
    'กำแพงเพชร': 'Kamphaeng Phet',
    'กาญจนบุรี': 'Kanchanaburi',
    'ขอนแก่น': 'Khon Kaen',
    'กระบี่': 'Krabi',
    'ลำปาง': 'Lampang',
    'ลำพูน': 'Lamphun',
    'เลย': 'Loei',
    'ลพบุรี': 'Lop Buri',
    'แม่ฮ่องสอน': 'Mae Hong Son',
    'มหาสารคาม': 'Maha Sarakham',
    'มุกดาหาร': 'Mukdahan',
    'นครนายก': 'Nakhon Nayok',
    'นครปฐม': 'Nakhon Pathom',
    'นครพนม': 'Nakhon Phanom',
    'นครราชสีมา': 'Nakhon Ratchasima',
    'นครสวรรค์': 'Nakhon Sawan',
    'นครศรีธรรมราช': 'Nakhon Si Thammarat',
    'น่าน': 'Nan',
    'นราธิวาส': 'Narathiwat',
    'หนองบัวลำภู': 'Nong Bua Lam Phu',
    'หนองคาย': 'Nong Khai',
    'นนทบุรี': 'Nonthaburi',
    'ปทุมธานี': 'Pathum Thani',
    'ปัตตานี': 'Pattani',
    'พังงา': 'Phangnga',
    'พัทลุง': 'Phatthalung',
    'พะเยา': 'Phayao',
    'เพชรบูรณ์': 'Phetchabun',
    'เพชรบุรี': 'Phetchaburi',
    'พิจิตร': 'Phichit',
    'พิษณุโลก': 'Phitsanulok',
    'พระนครศรีอยุธยา': 'Phra Nakhon Si Ayutthaya',
    'แพร่': 'Phrae',
    'ภูเก็ต': 'Phuket',
    'ปราจีนบุรี': 'Prachin Buri',
    'ประจวบคีรีขันธ์': 'Prachuap Khiri Khan',
    'ระนอง': 'Ranong',
    'ราชบุรี': 'Ratchaburi',
    'ระยอง': 'Rayong',
    'ร้อยเอ็ด': 'Roi Et',
    'สระแก้ว': 'Sa Kaeo',
    'สกลนคร': 'Sakon Nakhon',
    'สมุทรปราการ': 'Samut Prakan',
    'สมุทรสาคร': 'Samut Sakhon',
    'สมุทรสงคราม': 'Samut Songkhram',
    'สระบุรี': 'Saraburi',
    'สตูล': 'Satun',
    'สิงห์บุรี': 'Sing Buri',
    'ศรีสะเกษ': 'Si Sa Ket',
    'สงขลา': 'Songkhla',
    'สุโขทัย': 'Sukhothai',
    'สุพรรณบุรี': 'Suphan Buri',
    'สุราษฎร์ธานี': 'Surat Thani',
    'สุรินทร์': 'Surin',
    'ตาก': 'Tak',
    'ตรัง': 'Trang',
    'ตราด': 'Trat',
    'อุบลราชธานี': 'Ubon Ratchathani',
    'อุดรธานี': 'Udon Thani',
    'อุทัยธานี': 'Uthai Thani',
    'อุตรดิตถ์': 'Uttaradit',
    'ยะลา': 'Yala',
    'ยโสธร': 'Yasothon',
    'อื่นๆ': 'Others',

    // basin
    'โขงตะวันออกเฉียงเหนือ': 'Northeast Khong',
    'โขงเหนือ': 'North Khong',
    'เจ้าพระยา': 'Chao Phraya',
    'ชายฝั่งทะเลตะวันออก': 'East Coast Gulf',
    'ชี': 'Chi',
    'โตนเลสาป': 'Tonle Sap',
    'ทะเลสาบสงขลา': 'Thale Sap Songkhla',
    'ท่าจีน': 'Tha Chin',
    'บางปะกง': 'Bang Pakong',
    'ป่าสัก': 'Pasak',
    'ปิง': 'Ping',
    'เพชรบุรี-ประจวบคีรีขันธ์': 'Phetchaburi - Prachuap Khiri Khan',
    'ภาคใต้ฝั่งตะวันตก': 'Peninsula - West Coast',
    'ภาคใต้ฝั่งตะวันออกตอนบน': 'Peninsula - Upper East Coast',
    'ภาคใต้ฝั่งตะวันออกตอนล่าง': 'Peninsula - Lower East Coast',
    'มูล': 'Mun',
    'แม่กลอง': 'Mae Klong',
    'ยม': 'Yom',
    'วัง': 'Wang',
    'สะแกกรัง': 'Sakae Krang',
    'สาละวิน': 'Salawin',
  },
};

export default en;
